// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhn_wx bhn_jb bhn_xl bhn_i bhn_j bhn_q bhn_vt bhn_et bhn_so bhn_sp bhn_eg","CommentsButton__icon":"il_b bhn_rz"};